import { withStatus } from 'hoc/Status/Status';
import Component from './PersonalInformationsForm';
import { PersonalInformationsFormProps } from './interfaces';

const PersonalInformations =
  withStatus<PersonalInformationsFormProps>(Component);

export default PersonalInformations;
